import React, { useState, useEffect } from "react";
import ProductDetails from "../ProductDetails/ProductDetails"; // تأكد من المسار الصحيح
import "./Products.css";

const commonStyles = {
  container: "layout_container",
  headerWrapper: "Header_wrapper",
  headerSubtitle: "Header_subtitle",
  headerTitle: "Header_title",
};

const SectionHeader = ({ title, subtitle }) => (
  <div className={commonStyles.headerWrapper}>
    <span className={commonStyles.headerSubtitle}>{subtitle}</span>
    <h2 className={commonStyles.headerTitle}>{title}</h2>
  </div>
);

const Products = () => {
  const [activeFilter, setActiveFilter] = useState("marshmallow");
  const [selectedProduct, setSelectedProduct] = useState(null); // حالة المنتج المختار

  const filters = [
    { id: "marshmallow", label: "بسكويت مع مارشميلو" },
    { id: "coated", label: "بسكويت مغطس" },
    { id: "jelly", label: "بسكويت مع الجيلي" },
    { id: "cream", label: "بسكويت محشي بالكريمة" },
    { id: "cake", label: "كيك محشي بالمارشميلو" },
  ];

  const products = [
    {
      id: 1,
      name: "Hugy Puff",
      category: "marshmallow",
      description: "بسكويت مع المارشميلو مغطى بالفارماسيل",
      weight: "24g",
      packaging: " 6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "دقيق الطحين",
        "سكر",
        "جلكوز ",
        "زيوت نباتية مهدرجة بالكامل",
        "حليب خالي الدسم بودرة",
        "مصل الحليب",
        "سوربيتول E420",
        "جيلاتين بقري",
        "غليسرين ",
        "ملح الطعام",
        "مونوغلسرايد",
        "منكهات مماثلة للطبيعة",
        "ليستين الصويا (مستحلب E322)",
        "مواد حافظة (سوربات البوتاسيوم E202)",
        "مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الامونيوم)",
      ],
      images: [
        "/images/Product19/HuggyPuff1.webp",
        "/images/Product19/HuggyPuff2.webp",
        "/images/Product19/HuggyPuff3.webp",
      ],
      img: "/images/Product19/HuggyPuffEaten.webp",
    },
    {
      id: 2,
      name: "Bisco Moosh",
      category: "marshmallow",
      description: "بسكويت محشي بالمارشميللو المغطس بالشوكولا",
      weight: "30g",
      packaging: "12 علبة / الطرد - 12 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة",
        "دقيق الطحين",
        "جلوكوز",
        "كاكاو طبيعي",
        "كتلة الكاكاو",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "سوربيتول E420",
        "جيلاتين بقري",
        "ليستين الصويا E322 (مستحلب)",
        "غلسرين",
        "بيروفوسفات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "سوربات البوتاسيوم E202 (مواد حافظة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
      ],
      images: [
        "/images/Product6/BiscoMoosh1.webp",
        "/images/Product6/BiscoMoosh2.webp",
        "/images/Product6/BiscoMoosh3.webp",
      ],
      img: "/images/Product6/BiscoMooshEaten.webp",
    },
    {
      id: 3,
      name: "Histeria Max",
      category: "coated",
      description: "بسكويت محشي بكريمة الشوكولا و المغطس بالشوكولا",
      weight: "30g",
      packaging: "12 علبة / الطرد - 12 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة",
        "دقيق القمح",
        "جلوكوز",
        "بودرة الكاكاو",
        "كتلة الكاكاو",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "ديكستروز",
        "ملح الطعام",
        "ليستين الصويا E322 (مستحلب)",
        "منكهات مماثلة للطبيعة",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
      ],
      images: [
        "/images/Product1/HisteriaMax1.webp",
        "/images/Product1/HisteriaMax2.webp",
        "/images/Product1/HisteriaMax3.webp",
      ],
      img: "/images/Product1/HisteriaMaxEaten.webp",
    },
    {
      id: 4,
      name: "Histeria Max Milk",
      category: "coated",
      description: "بسكويت محشي بكريم الحليب المغطس بالشوكولا",
      weight: "30g",
      packaging: "12 علبة / الطرد - 12 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة",
        "دقيق القمح",
        "جلوكوز",
        "بودرة الكاكاو",
        "كتلة الكاكاو",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "ديكستروز",
        "ملح الطعام",
        "ليستين الصويا E322 (مستحلب)",
        "منكهات مماثلة للطبيعة",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
      ],
      images: [
        "/images/Product5/HisteriaMaxWhite1.webp",
        "/images/Product5/HisteriaMaxWhite2.webp",
        "/images/Product5/HisteriaMaxWhite3.webp",
      ],
      img: "/images/Product5/HisteriaMaxWhiteEaten.webp",
    },
    {
      id: 5,
      name: "Opaliz",
      category: "coated",
      description: "بسكويت مع الكراميل المغطس بالشوكولا",
      weight: "28g",
      packaging: "12 علبة / الطرد - 12 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة",
        "دقيق الطحين",
        "جلوكوز",
        "بودرة الكاكاو",
        "كتلة الكاكاو",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "جيلاتين بقري",
        "ليستين الصويا E322 (مستحلب)",
        "غليسرين",
        "دكستروز",
        "نشاء معدل",
        "بيروفوسفات الصوديوم E450-l (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "حمض الليمون",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
      ],
      images: [
        "/images/Product4/Opaliz1.webp",
        "/images/Product4/Opaliz2.webp",
        "/images/Product4/Opaliz3.webp",
      ],
      img: "/images/Product4/OpalizEaten.webp",
    },
    {
      id: 6,
      name: "Bisco Jell Orange",
      category: "jelly",
      description: "بسكويت مع جيلي البرتقال",
      img: "/images/Product7/BiscojellOrangeEaten.webp",
      weight: "22g",
      packaging: "6 علبة / الطرد - 24 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "ماء",
        "دقيق القمح",
        "جلكوز",
        "حليب خالي من الدسم",
        "سوربيتول",
        "بكتين",
        "ليستين الصويا E322",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الامونيوم (مواد رافعة)",
        "ملح الطعام",
        "فانيليا",
        "سوربات البوتاسيوم (مواد حافظة)",
        "حمض الليمون",
        "جيلاتين بقري",
        "منكهات مماثلة للطبيعة",
        "ملونات طبيعية (E122 - E110)",
      ],
      images: [
        "/images/Product7/BiscojellOrange1.webp",
        "/images/Product7/BiscojellOrange2.webp",
        "/images/Product7/BiscojellOrange3.webp",
      ],
    },
    {
      id: 7,
      name: "Bisco Jell Berry",
      category: "jelly",
      description: "بسكويت مع جيلي التوت",
      img: "/images/Product8/BiscojellBerryEaten.webp",
      weight: "22g",
      packaging: "6 علبة / الطرد - 24 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "ماء",
        "دقيق القمح",
        "جلكوز",
        "حليب خالي من الدسم",
        "سوربيتول",
        "بكتين",
        "ليستين الصويا E322",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الامونيوم (مواد رافعة)",
        "ملح الطعام",
        "فانيليا",
        "سوربات البوتاسيوم (مواد حافظة)",
        "حمض الليمون",
        "جيلاتين بقري",
        "منكهات مماثلة للطبيعة",
        "ملونات طبيعية (E133)",
      ],
      images: [
        "/images/Product8/BiscojellBerry1.webp",
        "/images/Product8/BiscojellBerry2.webp",
        "/images/Product8/BiscojellBerry3.webp",
      ],
    },
    {
      id: 8,
      name: "Bisco Jell Strawberry",
      category: "jelly",
      description: "بسكويت مع جيلي الفريز",
      img: "/images/Product9/BiscojellStrawberryEaten.webp",
      weight: "22g",
      packaging: "6 علبة / الطرد - 24 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "ماء",
        "دقيق القمح",
        "جلكوز",
        "حليب خالي من الدسم",
        "سوربيتول",
        "بكتين",
        "ليستين الصويا E322",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الامونيوم (مواد رافعة)",
        "ملح الطعام",
        "فانيليا",
        "سوربات البوتاسيوم (مواد حافظة)",
        "حمض الليمون",
        "جيلاتين بقري",
        "منكهات مماثلة للطبيعة",
        "ملونات طبيعية (E122)",
      ],
      images: [
        "/images/Product9/BiscojellStrawberry1.webp",
        "/images/Product9/BiscojellStrawberry2.webp",
        "/images/Product9/BiscojellStrawberry3.webp",
      ],
    },
    {
      id: 9,
      name: "Bisco Jell Apricot",
      category: "jelly",
      description: "بسكويت مع جيي المشمش",
      img: "/images/Product10/BiscojellApricotEaten.webp",
      weight: "22g",
      packaging: "6 علبة / الطرد - 24 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "ماء",
        "دقيق القمح",
        "جلكوز",
        "حليب خالي من الدسم",
        "سوربيتول",
        "بكتين",
        "ليستين الصويا E322",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الامونيوم (مواد رافعة)",
        "ملح الطعام",
        "فانيليا",
        "سوربات البوتاسيوم (مواد حافظة)",
        "حمض الليمون",
        "جيلاتين بقري",
        "منكهات مماثلة للطبيعة",
        "ملونات طبيعية (E122 - E110)",
      ],
      images: [
        "/images/Product10/BiscojellApricot1.webp",
        "/images/Product10/BiscojellApricot2.webp",
        "/images/Product10/BiscojellApricot3.webp",
      ],
    },
    {
      id: 10,
      name: "Bisco Max",
      category: "cream",
      description: "بسكويت الكاكاو محشي بكريم الحليب",
      img: "/images/Product12/BiscoMaxChocoEaten.webp",
      weight: "24g",
      packaging: "6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "مستحلب ليستين الصويا E322",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
      ],
      images: [
        "/images/Product12/BiscoMaxChoco1.webp",
        "/images/Product12/BiscoMaxChoco2.webp",
        "/images/Product12/BiscoMaxChoco3.webp",
      ],
    },
    {
      id: 11,
      name: "Bisco Max",
      category: "cream",
      description: "بسكويت الحليب محشي بكريم الشوكولا",
      img: "/images/Product13/BiscoMaxChocoCreamEaten.webp",
      weight: "24g",
      packaging: "6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "مستحلب ليستين الصويا E322",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
      ],
      images: [
        "/images/Product13/BiscoMaxChocoCream1.webp",
        "/images/Product13/BiscoMaxChocoCream2.webp",
        "/images/Product13/BiscoMaxChocoCream3.webp",
      ],
    },
    {
      id: 12,
      name: "Bisco Max",
      category: "cream",
      description: "بسكويت الكاكاو محشي بكريم الحليب",
      img: "/images/Product14/BiscoMaxCocoaBiscuitEaten.webp",
      weight: "24g",
      packaging: "6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "مستحلب ليستين الصويا E322",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
      ],
      images: [
        "/images/Product14/BiscoMaxCocoaBiscuit1.webp",
        "/images/Product14/BiscoMaxCocoaBiscuit2.webp",
        "/images/Product14/BiscoMaxCocoaBiscuit3.webp",
      ],
    },
    {
      id: 13,
      name: "Bisco Max",
      category: "cream",
      description: "بسكويت الكاكاو محشي بكريم الشوكولا",
      img: "/images/Product15/BiscoMaxChocoBiscuitEaten.webp",
      weight: "24g",
      packaging: "6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "مستحلب ليستين الصويا E322",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
      ],
      images: [
        "/images/Product15/BiscoMaxChocoBiscuit1.webp",
        "/images/Product15/BiscoMaxChocoBiscuit2.webp",
        "/images/Product15/BiscoMaxChocoBiscuit3.webp",
      ],
    },
    {
      id: 14,
      name: "Bisco Max",
      category: "cream",
      description: "بسكويت الحليب محشي بكريم الفريز",
      img: "/images/Product16/BiscoMaxStrawberryCreamEaten.webp",
      weight: "24g",
      packaging: "6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "مستحلب ليستين الصويا E322",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
        "ملون غذائي E122",
      ],
      images: [
        "/images/Product16/BiscoMaxStrawberryCream1.webp",
        "/images/Product16/BiscoMaxStrawberryCream2.webp",
        "/images/Product16/BiscoMaxStrawberryCream3.webp",
      ],
    },
    {
      id: 15,
      name: "Bisco Max",
      category: "cream",
      description: "بسكويت القهوة محشي بكريم القهوة",
      img: "/images/Product17/BiscoMaxCoffeeEaten.webp",
      weight: "24g",
      packaging: "6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "مستحلب ليستين الصويا E322",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
      ],
      images: [
        "/images/Product17/BiscoMaxCoffee1.webp",
        "/images/Product17/BiscoMaxCoffee2.webp",
        "/images/Product17/BiscoMaxCoffee3.webp",
      ],
    },
    {
      id: 16,
      name: "Bisco Max",
      category: "cream",
      description: "بسكويت الكراميل محشي بكريم الكراميل",
      img: "/images/Product18/BiscoMaxCaramelEaten.webp",
      weight: "24g",
      packaging: "6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "مستحلب ليستين الصويا E322",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
      ],
      images: [
        "/images/Product18/BiscoMaxCaramel1.webp",
        "/images/Product18/BiscoMaxCaramel2.webp",
        "/images/Product18/BiscoMaxCaramel3.webp",
      ],
    },
    {
      id: 17,
      name: "Bisco Max",
      category: "cream",
      description: "بسكويت الحليب محشي بكريم البرتقال",
      img: "/images/Product11/BiscoMaxOrangeEaten.webp",
      weight: "24g",
      packaging: "6 علبة / طرد - 24 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة بالكامل",
        "دقيق القمح",
        "جلوكوز",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "مستحلب ليستين الصويا E322",
        "بيروفوسفات الصوديوم E450-1 (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "بيكربونات الأمونيوم (مواد رافعة)",
        "ملح الطعام",
        "منكهات مماثلة للطبيعة",
        "ملون غذائي E110",
      ],
      images: [
        "images/Product11/BiscoMaxOrange1.webp",
        "images/Product11/BiscoMaxOrange2.webp",
        "images/Product11/BiscoMaxOrange3.webp",
      ],
    },
    {
      id: 18,
      name: "Hugy Moosh Milk",
      category: "cake",
      description: "كيك الحليب مع المارشميللو المغطس بالشوكولا",
      weight: "30g",
      packaging: " 12 علبة / طرد - 12 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة",
        "مياه",
        "دقيق القمح (دقيق الطحين)",
        "جلوكوز",
        "كاكاو طبيعي",
        "كتلة الكاكاو",
        "بيض",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "سوربيتول",
        "جيلاتين بقري",
        "نشاء معدل",
        "ديكستروز",
        "ليستين الصويا E322",
        "غلسرين",
        "كيك جيل",
        "بيروفوسفات الصوديوم (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "ملح الطعام",
        "نكهات (فانيليا، حليب، زبدة)",
        "سوربات بوتاسيوم (مادة حافظة)",
        "بروبلين جليكول",
      ],
      images: [
        "/images/Product3/HugyMooshWhite1.webp",
        "/images/Product3/HugyMooshWhite2.webp",
        "/images/Product3/HugyMooshWhite3.webp",
      ],
      img: "/images/Product3/HugyMooshWhiteEaten.webp",
    },
    {
      id: 19,
      name: "Hugy Moosh Dark",
      category: "cake",
      description: "كيك الشوكولا مع المارشميللو المغطس بالشوكولا",
      weight: "30g",
      packaging: "12 علبة / الطرد - 12 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة",
        "مياه",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "كتلة الكاكاو",
        "بيض طازج",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "سوربيتول (مرطب)",
        "جيلاتين بقري حلال",
        "نشاء معدل",
        "ديكستروز",
        "غلسرين",
        "كيك جيل",
        "ملح الطعام",
        "بروبلين جليكول",
        "ليستين الصويا E322 (مستحلب)",
        "بيروفوسفات الصوديوم (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "منكهات (فانيليا، حليب، زبدة)",
        "سوربات بوتاسيوم (مادة حافظة)",
      ],
      images: [
        "/images/Product2/HugyMooshDark1.webp",
        "/images/Product2/HugyMooshDark2.webp",
        "/images/Product2/HugyMooshDark3.webp",
      ],
      img: "/images/Product2/HugyMooshDarkEaten.webp",
    },
  ];

  const filteredProducts = products.filter((p) => p.category === activeFilter);

  useEffect(() => {
    if (!selectedProduct) {
      const observerOptions = { threshold: 0.1 };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      }, observerOptions);

      const cards = document.querySelectorAll(".Catalog_card");
      cards.forEach((card) => observer.observe(card));
      return () => observer.disconnect();
    }
  }, [filteredProducts, selectedProduct]);

  // إذا كان هناك منتج مختار، اعرض صفحة التفاصيل
  if (selectedProduct) {
    return (
      <ProductDetails
        product={selectedProduct}
        onBack={() => setSelectedProduct(null)}
      />
    );
  }

  return (
    <div className="biscuit-container">
      <div className={commonStyles.container}>
        <SectionHeader title="تصفح منتجات البسكويت" subtitle="جودة وفخامة" />

        <div className="Catalog_filterWrapper">
          {filters.map((filter) => (
            <button
              key={filter.id}
              className={`Catalog_filterBtn ${
                activeFilter === filter.id ? "Catalog_filterBtnActive" : ""
              }`}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        <div className="Catalog_grid">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="Catalog_card"
              onClick={() => setSelectedProduct(product)} // عند النقر، يتم اختيار المنتج
              style={{ cursor: "pointer" }}
            >
              <div className="Catalog_imgContainer">
                <img
                  src={product.img}
                  alt={product.name}
                  className="Catalog_img"
                />
              </div>
              <div className="Catalog_info">
                <h4 className="Catalog_name">{product.name}</h4>
                <div className="Catalog_desc">
                  <p>{product.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
